// Mission statements sometimes contain unfilled template placeholders - "XX" or
// any bracketed text like "[...]". Those must be replaced before a statement
// can be saved or selected, so the screen highlight and the validation share this one pattern.
// Same matching the screen's flashing highlight always used: "[...]" pairs and literal "XX" (any case).
const PLACEHOLDER_PATTERN = /\[[^\]]*\]|XX/gi;

export const PLACEHOLDER_ERROR_DURATION = 10000;

// Unique placeholder words found in the text, in order of appearance, e.g. ["[...]", "XX"].
export const getMissionPlaceholders = (text) => {
  if (!text) return [];
  const found = text.match(new RegExp(PLACEHOLDER_PATTERN.source, PLACEHOLDER_PATTERN.flags)) || [];
  return found.filter((word, index) => found.indexOf(word) === index);
};

export const getPlaceholderErrorMessage = (text) => {
  const words = getMissionPlaceholders(text).map((word) => `"${word}"`).join(', ');
  return `Please replace the following text in your Mission Statement before continuing: ${words}.`;
};

export const hasMissionPlaceholders = (text) => {
  if (!text) return false;
  PLACEHOLDER_PATTERN.lastIndex = 0;
  return PLACEHOLDER_PATTERN.test(text);
};

// The statement already chosen for the PMA qualifies on its own content.
// Agents do not have to open every mission-statement option when this is true.
export const missionStatementContentQualifies = (text) => {
  if (typeof text !== "string" || !text.trim()) return false;
  return !hasMissionPlaceholders(text);
};

// Splits text into [{ text, isPlaceholder }] segments for highlighting.
export const splitMissionPlaceholders = (text) => {
  if (!text) return [];
  const parts = [];
  let lastIndex = 0;
  const pattern = new RegExp(PLACEHOLDER_PATTERN.source, PLACEHOLDER_PATTERN.flags);
  let match;
  while ((match = pattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ text: text.substring(lastIndex, match.index), isPlaceholder: false });
    }
    parts.push({ text: match[0], isPlaceholder: true });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) {
    parts.push({ text: text.substring(lastIndex), isPlaceholder: false });
  }
  return parts;
};
